<template>
  <div class="about">
    <div class="content">
      <h2>About</h2>

      <p>
        This is a hobby project that was born out of a desire to test implementing a simple single-page-application using the
        <a
          href="https://vuejs.org/"
          target="_blank"
          rel="noopener noreferrer"
        >Vue framework</a>. It has slowly but surely evolved
        into something more complicated, where tabs are used to navigate between
        views demonstrating various frontend technologies and a backend is set up for state persistance and execution of more complicated tasks. It may change at any time without notice.
      </p>
      <p>Click the tabs at the top to try out some applications.</p>

      <h3>3rd-party Software Dependencies</h3>

      <div class="row">
        <div class="row-header">
          <div class="cell">
            <div>
              <strong>Dependency</strong>
            </div>
          </div>
          <div class="cell">
            <div>
              <strong>License</strong>
            </div>
          </div>
          <div class="cell">
            <div>
              <strong>Show/Hide License</strong>
            </div>
          </div>
        </div>
      </div>

      <div v-for="dependency in dependencies" v-bind:key="dependency.id">
        <div v-if="dependency.expanded">
          <div class="row">
            <div class="row-header">
              <div class="cell">
                <a
                  class="cell-content"
                  v-bind:href="dependency.projectLink"
                  target="_blank"
                  rel="noopener noreferrer"
                >{{ dependency.name }}</a>
              </div>
              <div class="cell">
                <a
                  class="cell-content"
                  v-bind:href="dependency.link"
                  target="_blank"
                  rel="noopener noreferrer"
                >{{ dependency.licenseName }}</a>
              </div>
              <div class="cell">
                <button class="cell-content" v-on:click="toggleDependencyExpansion(dependency)">Hide</button>
              </div>
            </div>
            <p class="full-license">{{ dependency.fulltext }}</p>
            <br />
          </div>
        </div>
        <div v-else>
          <div class="row">
            <div class="row-header">
              <div class="cell">
                <a
                  class="cell-content"
                  v-bind:href="dependency.projectLink"
                  target="_blank"
                  rel="noopener noreferrer"
                >{{ dependency.name }}</a>
              </div>
              <div class="cell">
                <a
                  class="cell-content"
                  v-bind:href="dependency.link"
                  target="_blank"
                  rel="noopener noreferrer"
                >{{ dependency.licenseName }}</a>
              </div>
              <div class="cell">
                <button class="cell-content" v-on:click="toggleDependencyExpansion(dependency)">Show</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer">
      Copyright © {{new Date().getFullYear()}}
      <a
        target="_blank"
        href="https://amani.kilumanga.com"
      >Amani Kilumanga</a>, All rights reserved
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      showFullLicenses: false,
      dependencies: [
        {
          name: "Chart.js",
          licenseName: "MIT",
          projectLink: "https://github.com/chartjs/Chart.js",
          link:
            "https://github.com/chartjs/Chart.js/blob/9140ef7e671b6b3c316d777b2730bc182d84ea97/LICENSE.md",
          expanded: false,
          fulltext:
            'The MIT License (MIT)\r\n\r\nCopyright (c) 2018 Chart.js Contributors\r\n\r\nPermission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:\r\n\r\nThe above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\r\n\r\nTHE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.'
        },
        {
          name: "vue",
          licenseName: "MIT",
          projectLink: "https://github.com/vuejs/vue",
          link:
            "https://github.com/vuejs/vue/blob/d483a49c86874b2e75863b661f81feecd46ae721/LICENSE",
          expanded: false,
          fulltext:
            'The MIT License (MIT)\r\n\r\nCopyright (c) 2013-present, Yuxi (Evan) You\r\n\r\nPermission is hereby granted, free of charge, to any person obtaining a copy\r\nof this software and associated documentation files (the "Software"), to deal\r\nin the Software without restriction, including without limitation the rights\r\nto use, copy, modify, merge, publish, distribute, sublicense, and/or sell\r\ncopies of the Software, and to permit persons to whom the Software is\r\nfurnished to do so, subject to the following conditions:\r\n\r\nThe above copyright notice and this permission notice shall be included in\r\nall copies or substantial portions of the Software.\r\n\r\nTHE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\r\nIMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\r\nFITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\r\nAUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\r\nLIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\r\nOUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN\r\nTHE SOFTWARE.'
        },
        {
          name: "vue-chartjs",
          licenseName: "MIT",
          projectLink: "https://github.com/apertureless/vue-chartjs",
          link:
            "https://github.com/apertureless/vue-chartjs/blob/6dcd213c3177ee966d08377b789c855a1a564eaa/LICENSE.txt",
          expanded: false,
          fulltext:
            'MIT License\r\n\r\nCopyright (c) 2016 Jakub Juszczak\r\n\r\nPermission is hereby granted, free of charge, to any person obtaining a copy\r\nof this software and associated documentation files (the "Software"), to deal\r\nin the Software without restriction, including without limitation the rights\r\nto use, copy, modify, merge, publish, distribute, sublicense, and/or sell\r\ncopies of the Software, and to permit persons to whom the Software is\r\nfurnished to do so, subject to the following conditions:\r\n\r\nThe above copyright notice and this permission notice shall be included in all\r\ncopies or substantial portions of the Software.\r\n\r\nTHE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\r\nIMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\r\nFITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\r\nAUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\r\nLIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\r\nOUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\r\nSOFTWARE.'
        },
        {
          name: "vue-confetti",
          licenseName: "MIT",
          projectLink: "https://github.com/alexandermendes/vue-confetti",
          link:
            "https://github.com/alexandermendes/vue-confetti/blob/77ba8567a242b23bb028bd42c8bc2b3ee6b741d2/LICENSE",
          expanded: false,
          fulltext:
            'MIT License\r\n\r\nCopyright (c) 2017 Alexander Mendes\r\n\r\nPermission is hereby granted, free of charge, to any person obtaining a copy\r\nof this software and associated documentation files (the "Software"), to deal\r\nin the Software without restriction, including without limitation the rights\r\nto use, copy, modify, merge, publish, distribute, sublicense, and/or sell\r\ncopies of the Software, and to permit persons to whom the Software is\r\nfurnished to do so, subject to the following conditions:\r\n\r\nThe above copyright notice and this permission notice shall be included in all\r\ncopies or substantial portions of the Software.\r\n\r\nTHE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\r\nIMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\r\nFITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\r\nAUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\r\nLIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\r\nOUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\r\nSOFTWARE.'
        },
        {
          name: "vue-resource",
          licenseName: "MIT",
          projectLink: "https://github.com/pagekit/vue-resource",
          link:
            "https://github.com/pagekit/vue-resource/blob/e25df446e1e94f0134888d9bf8fc75bf8ce91d49/LICENSE",
          expanded: false,
          fulltext:
            'The MIT License (MIT)\r\n\r\nCopyright (c) 2015-2017 steffans\r\n\r\nPermission is hereby granted, free of charge, to any person obtaining a copy\r\nof this software and associated documentation files (the "Software"), to deal\r\nin the Software without restriction, including without limitation the rights\r\nto use, copy, modify, merge, publish, distribute, sublicense, and/or sell\r\ncopies of the Software, and to permit persons to whom the Software is\r\nfurnished to do so, subject to the following conditions:\r\n\r\nThe above copyright notice and this permission notice shall be included in\r\nall copies or substantial portions of the Software.\r\n\r\nTHE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\r\nIMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\r\nFITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\r\nAUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\r\nLIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\r\nOUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN\r\nTHE SOFTWARE.'
        },
        {
          name: "vue-router",
          licenseName: "MIT",
          projectLink: "https://github.com/vuejs/vue-router",
          link:
            "https://github.com/vuejs/vue-router/blob/701d02b810da200b9ee7bac757d62b628327c6dd/LICENSE",
          expanded: false,
          fulltext:
            'MIT License\r\n\r\nCopyright (c) 2013-present Evan You\r\n\r\nPermission is hereby granted, free of charge, to any person obtaining a copy\r\nof this software and associated documentation files (the "Software"), to deal\r\nin the Software without restriction, including without limitation the rights\r\nto use, copy, modify, merge, publish, distribute, sublicense, and/or sell\r\ncopies of the Software, and to permit persons to whom the Software is\r\nfurnished to do so, subject to the following conditions:\r\n\r\nThe above copyright notice and this permission notice shall be included in all\r\ncopies or substantial portions of the Software.\r\n\r\nTHE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\r\nIMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\r\nFITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\r\nAUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\r\nLIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\r\nOUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE\r\nSOFTWARE.'
        },
        {
          name: "Vue2Leaflet",
          licenseName: "MIT",
          projectLink: "https://github.com/KoRiGaN/Vue2Leaflet",
          link:
            "https://github.com/KoRiGaN/Vue2Leaflet/blob/d5a48eaa4a665b16a24653f1d579c3a1cdb36ee6/LICENSE",
          expanded: false,
          fulltext:
            'The MIT License (MIT)\r\n\r\nCopyright (c) 2016-2017 Mickael Bouchaud\r\n\r\nPermission is hereby granted, free of charge, to any person obtaining a copy\r\nof this software and associated documentation files (the "Software"), to deal\r\nin the Software without restriction, including without limitation the rights\r\nto use, copy, modify, merge, publish, distribute, sublicense, and/or sell\r\ncopies of the Software, and to permit persons to whom the Software is\r\nfurnished to do so, subject to the following conditions:\r\n\r\nThe above copyright notice and this permission notice shall be included in\r\nall copies or substantial portions of the Software.\r\n\r\nTHE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\r\nIMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\r\nFITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\r\nAUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\r\nLIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\r\nOUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN\r\nTHE SOFTWARE.'
        }
      ]
    };
  },
  created: function() {
    this.dependencies.sort((a, b) => a.name.localeCompare(b.name));
    var query = this.$route.query;
    var openidNs = this.$route.query["openid.ns"];
    if (openidNs != undefined) {
      this.$router.push({
        path: "steam",
        query: query
      });
    }
  },
  methods: {
    toggleDependencyExpansion: function(dependency) {
      dependency.expanded = !dependency.expanded;
    },
    toggleShowFullLicenses: function() {
      this.showFullLicenses = !this.showFullLicenses;
    }
  }
};
</script>

<style scoped>
.about {
  height: 100vh;
}

.content {
  height: calc(100vh - 100px);
  overflow: auto;
}

.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 50px;
  line-height: 50px;
  text-align: center;
}

.row {
  transition: 0.3s;
}

.row-header {
  height: 50px;
  width: auto;
  margin: 0 auto;

  display: flex;
  align-items: center;
  justify-content: center;
}

.row:hover {
  background-color: #bfbfbf;
}

.cell {
  height: 100%;
  width: 200px;
  max-width: 200px;

  display: flex;
  align-items: center;
  justify-content: center;

  transition: 0.3s;
}

.cell a {
  height: 100%;
  display: block;
  text-decoration: none;
  color: inherit;

  display: flex;
  align-items: center;
  justify-content: center;
}

.cell:hover {
  background-color: #f2f2f2;
}

.cell button {
  height: 100%;
  border: none;
  background-color: inherit;
}

.cell-content {
  flex: 1;
}

h1,
h2 {
  padding-top: 20px;
  font-weight: normal;
}

table {
  margin: auto;
  border-collapse: collapse;
}

th,
td {
  text-align: left;
  border-bottom: 1px solid #ddd;
}

th {
  padding: 10px;
}

p {
  padding-left: 50px;
  padding-right: 50px;
  text-align: justify;
}

.full-license {
  white-space: pre-wrap;
  font-family: monospace;
}
</style>
